







































































import { Component, PropSync, Vue } from 'vue-property-decorator';

@Component
export default class GltfPointKeymap extends Vue {
  @PropSync ('useRoomEnv', { type: Boolean, default: true }) public syncedUseRoomEnv!: boolean;
}
